{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "draworder":"topdown",
         "id":2,
         "name":"Objects",
         "objects":[
                {
                 "height":160,
                 "id":1,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":96,
                 "x":256,
                 "y":0
                }, 
                {
                 "ellipse":true,
                 "height":64,
                 "id":2,
                 "name":"target",
                 "rotation":0,
                 "type":"target",
                 "visible":true,
                 "width":64,
                 "x":480,
                 "y":96
                }, 
                {
                 "height":0,
                 "id":3,
                 "name":"player",
                 "point":true,
                 "rotation":0,
                 "type":"player",
                 "visible":true,
                 "width":0,
                 "x":128,
                 "y":96
                }, 
                {
                 "height":160,
                 "id":4,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":96,
                 "x":256,
                 "y":288
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":3,
 "nextobjectid":5,
 "orientation":"orthogonal",
 "properties":[
        {
         "name":"levelName",
         "type":"string",
         "value":"Level 3"
        }, 
        {
         "name":"order",
         "type":"int",
         "value":2
        }],
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":20
}